import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import type { LayoutBehavior } from './layout-section.model';
import styles from './layout-section.styles';

/**
 * @slot default - The content of the layout section
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksLayoutSection extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Behavioral variants
   * <cat-text-passage size="sm">
   * <ul>
   * <li>**sticky** allows the layout section to stick to the screen until the section reaches the bottom of the layout or the next layout section.</li>
   * </ul>
   * </cat-text-passage>
   */
  @property({ type: String })
  behavior: LayoutBehavior;

  /**
   * Top style
   * 1) Used to create dynamic sticky containers that can be adjusted based on the content
   */
  @property({ type: String })
  top: string | undefined = '1rem';

  render(): TemplateResult<1> {
    const componentClassName = this.componentClassNames('cat-c-layout-section', {
      'cat-c-layout-section--sticky': this.behavior === 'sticky'
    });

    return html`
      <div part="base" class="${componentClassName}" style=${'top: ' + this.top}>
        <slot part="part-default"></slot>
      </div>
    `;
  }
}

if (customElements.get('cat-layout-section') === undefined) {
  customElements.define('cat-layout-section', BlocksLayoutSection);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-layout-section': BlocksLayoutSection;
  }
}
